import { PostSliderController } from './post-slider.controller'

function postSlider () {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: '/posts/directives/post-slider/post-slider-directive.html?$$REVISION$$',
    controller: PostSliderController
  }
}

export { postSlider }
